import { genericFetchingActionCreator, genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

const name = 'FAQ'

export const fetchFAQs = () => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator(name, 'fetching'))
    fetch('/lgyhub/api/faqs', {
      method: 'GET',
      credentials: 'include'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'FAQs')
    }).then((response) => {
      dispatch(genericFetchingActionCreator(name, 'fetched', { faqs: (response || []) }))
    }).catch((error) => {
      console.error('There has been a problem getting FAQs:', error)
    })
  }
}

export const clearFAQMessages = () => (dispatch) => {
  dispatch(genericPostingActionCreator(name, 'init'))
}

const modifyFAQ = (url, question = '', answer = '', sortOrder = 0, faqCategoryDesc = '') => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator(name, 'posting'))
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ question, answer, sortOrder, faqCategoryDesc }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'updating this FAQ')
    }).then(() => {
      dispatch(genericPostingActionCreator(name, 'posted'))
      dispatch(fetchFAQs())
    }).catch((error) => {
      console.error('There has been a problem updating the FAQ:', error)
    })
  }
}

export const addFAQ = (question, answer, sortOrder, faqCategoryDesc) => modifyFAQ('/lgyhub/api/faqs', question, answer, sortOrder, faqCategoryDesc)
export const editFAQ = (id, question, answer, sortOrder, faqCategoryId) => modifyFAQ(`/lgyhub/api/faqs/update/${id}`, question, answer, sortOrder, faqCategoryId)
export const deleteFAQ = (id) => modifyFAQ(`/lgyhub/api/faqs/delete/${id}`)
